import React, { useEffect } from 'react';
import { flushSync } from 'react-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { hasPermissionWA } from 'businessLogic/checkExistOrVerifyPermissions';
import { isAnyOverlayFormVisible, isAnyInputFormVisible } from 'businessLogic/form';
import { closeModalsForPiwa } from 'actions/modal';
import { updateFetchingWA } from 'actions/waitingArea';
import ViewOneContent from '../components/pages/waiting-area/view-one/content';
import NotFoundPage from './NotFoundPage.js';

function WaitingAreaViewOnePage(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    flushSync(() => {
      return dispatch(updateFetchingWA(true));
    });
  }, []);

  const networkId = props.match.params.id;
  const storeValuesFromRedux = useSelector((state) => state);
  const fetchingWaitingArea = useSelector((state) => state.waitingAreaReducer.fetchingWaitingArea);
  const waitingAreaExist =
    fetchingWaitingArea === false ? hasPermissionWA(storeValuesFromRedux, networkId, 'VIEW') : true;
  const redirectToPageNotFound = useSelector((state) => state.sharedReducer.redirectToPageNotFound);
  const hasWaitingAreas = useSelector((state) => state.usersReducer.userProfile.hasWaitingAreas);

  if (redirectToPageNotFound || hasWaitingAreas == false || waitingAreaExist == false) {
    return <NotFoundPage dispatch={dispatch} preAction={closeModalsForPiwa} />;
  } else {
    return <ViewOneContent id={parseInt(props.match.params.id)} />;
  }
}

export default WaitingAreaViewOnePage;
